import React from 'react';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

interface Props {
  isOpenDeleteDialog?: boolean;
  handleToggleDeleteDialog: () => void;
  onSubmit: () => void;
}

export const DeletePredictionDialog = ({ isOpenDeleteDialog, handleToggleDeleteDialog, onSubmit }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage({
        id: 'common.warning_irreversible_delete_process',
        defaultMessage: 'Warning: This deletion is irreversible'
      })}
      onCancel={handleToggleDeleteDialog}
      open={!!isOpenDeleteDialog}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleToggleDeleteDialog} destructive>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" onClick={onSubmit} destructive>
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        }
        onSubmit={onSubmit}
      >
        <Typography fontSize="16px" mb={0}>
          <FormattedMessage
            id="predict.predictions.are_you_sure"
            defaultMessage="Are you sure you want to delete this prediction? Any reference to the prediction in a report or a formula in another prediction will be impacted."
          />
        </Typography>
      </Form>
    </Dialog>
  );
};
